import React from "react";
import FeatureLane from "components/FeatureLane";
import {DeliverableGroupKey, FeatureLaneModelWithStatus} from "data/models/feature-lane";

type DeliverableGroupProps = {
  id: DeliverableGroupKey,
  title: string | null,
  description: string | null;
  featureLanes: FeatureLaneModelWithStatus[],
}

const DeliverableGroup = ({id: deliverableGroupId, title, description, featureLanes}: DeliverableGroupProps) => {
  return <div className="flex flex-col md:p-6 md:mr-6 sm:py-6 sm:px-0 sm:mr-0">
    {title != null && <div className={"text-center"}>
      <span className={"text-2xl font-bold"}>{title}</span>
    </div>}
    {description !== null && <div className={"mb-8 text-center"}>
      <span className={"text-neutral-500"}>{description}</span>
    </div>}
    {featureLanes.map(
        (featureLaneProps, index) => <div key={index} className={"flex flex-col"}>
          <div>
            <FeatureLane {...featureLaneProps} id={featureLaneProps.id} deliverableGroupId={deliverableGroupId}/>
          </div>
        </div>
    )}
  </div>

}

export default DeliverableGroup;
